/**
 * The iframe host, and the only Public Grid route. This is where the checklist
 * card points: there is no intro or consent page in front of it.
 *
 * Minting happens when this page mounts rather than when the checklist loads —
 * the token lives 600 seconds, so one minted per card impression would mostly
 * expire unused and spend the rate-limit budget for nothing.
 */
export const PUBLIC_GRID_ROUTE = '/public-grid';

/** The existing utility contact list — the fallback when the embed fails. */
export const UTILITIES_ROUTE = '/utilities';

/**
 * Re-mint if the page has been open longer than this. The token is good for
 * `expiresIn` (600s); we refresh well short of that so a resident returning to
 * a backgrounded tab is not handed a dead frame.
 */
export const REMINT_AFTER_MS = 8 * 60 * 1000;

/**
 * How long we wait for an eligibility answer before giving up on it.
 *
 * This call sits on the critical path of first paint — `useDataForCards`,
 * `useDaisyChain` and the proof-of-utilities hub all hold their loading flag
 * until it resolves, so a partner that neither answers nor errors would hold
 * the whole checklist, not just the Connect power card. Apollo has no timeout
 * of its own, so a hung request waits forever.
 *
 * Long enough for a slow-but-working partner, short enough that the resident is
 * not held hostage to one. Tune it here; nothing else reads a duration.
 */
export const ELIGIBILITY_TIMEOUT_MS = 5000;
